import React from "react";

/**
 * The Win Room — typographic wordmark with bronze monogram.
 * variant: "horizontal" | "vertical" | "icon"
 * tone: "light" (default — for dark backgrounds) | "dark" (for light backgrounds)
 */
export default function Logo({ variant = "horizontal", tone = "light", className = "", "data-testid": testId }) {
  const ink = tone === "dark" ? "#0A0A0A" : "#F4F0EA";
  const bronze = "#B4835A";

  if (variant === "icon") {
    return (
      <span
        data-testid={testId || "logo-icon"}
        className={`monogram ${className}`}
        style={{ borderColor: bronze, color: bronze, background: "transparent" }}
        aria-label="The Win Room"
      >
        TWR
      </span>
    );
  }

  if (variant === "vertical") {
    return (
      <div
        data-testid={testId || "logo-vertical"}
        className={`inline-flex flex-col items-center gap-2 ${className}`}
        aria-label="The Win Room"
      >
        <span className="monogram" style={{ borderColor: bronze, color: bronze }}>TWR</span>
        <div className="flex flex-col items-center leading-none">
          <span className="font-serif text-base tracking-[0.42em] uppercase" style={{ color: ink }}>The</span>
          <span className="font-serif text-xl tracking-[0.32em] uppercase mt-1" style={{ color: ink }}>Win Room</span>
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid={testId || "logo-horizontal"}
      className={`inline-flex items-center gap-3 ${className}`}
      aria-label="The Win Room"
    >
      <span className="monogram" style={{ borderColor: bronze, color: bronze, width: 36, height: 36, fontSize: 11 }}>TWR</span>
      <div className="flex flex-col leading-none">
        <span className="font-sans text-[10px] tracking-[0.42em] uppercase" style={{ color: bronze }}>The</span>
        <span className="font-serif text-base sm:text-lg tracking-[0.22em] uppercase mt-0.5" style={{ color: ink }}>Win Room</span>
      </div>
    </div>
  );
}
